import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isService1Tenant } from '../../Utils/ServiceProviders/lumin';
import { BASE_URL } from '../../Utils/url';
import moment from 'moment';
import 'moment-timezone';
import './GoodnightProcess.scss';

// ─── PRODUCTION values (restore before commit) ───────────────────
const FORCE_SHOW = false;
const BLOCK_MINS = 19 * 60; // 7:00 PM ET = 1140
const END_MINS   = 21 * 60; // 9:00 PM ET = 1260
// ─────────────────────────────────────────────────────────────────

// ─── TEST values — uncomment to test locally ─────────────────────
// const FORCE_SHOW = true;
// const _N = (() => { const t = moment().tz('America/New_York'); return t.hours() * 60 + t.minutes(); })();
// const BLOCK_MINS = _N;
// const END_MINS   = _N + 20;
// ─────────────────────────────────────────────────────────────────

// ─── Action modal ────────────────────────────────────────────────
const ActionModal = ({ isVisible, tenantName, onClose }) => {
    if (!isVisible) return null;
    return (
        <div className="gn-overlay">
            <div className="gn-card">
                <button className="gn-modal-close" onClick={onClose} aria-label="Close">✕</button>
                <img src={`${BASE_URL.CDN}/tenants/${tenantName}/email/logo.png`} alt="" className="gn-logo" />
                <div className="gn-title">We're taking a quick break</div>
                <div className="gn-body">
                    Enrollment and adding a child aren't available from 7–9pm daily—no need to refresh, just try again after 9pm.
                </div>
            </div>
        </div>
    );
};

// Module-level setter — lets triggerGoodnightModal reach into the mounted component
let _setShowModal = null;

export const isGoodnightWindowActive = (props) => {
    if (FORCE_SHOW) return true;
    if (!isService1Tenant(props)) return false;
    const now  = moment().tz('America/New_York');
    const mins = now.hours() * 60 + now.minutes();
    return mins >= BLOCK_MINS && mins < END_MINS;
};

// Call this from any action screen — shows modal if goodnight window is active.
// Returns true if modal was triggered (caller should return/abort the action).
export const triggerGoodnightModal = (props) => {
    if (!isGoodnightWindowActive(props)) return false;
    if (_setShowModal) _setShowModal(true);
    return true;
};

const GoodnightProcess = (props) => {
    const [showModal, setShowModal] = useState(false);
    const tenantName = props.state?.theme?.values?.tenantFullName;

    useEffect(() => {
        _setShowModal = setShowModal;
        return () => { _setShowModal = null; };
    }, []);

    return (
        <ActionModal isVisible={showModal} tenantName={tenantName} onClose={() => setShowModal(false)} />
    );
};

function mapStateToProps(state) {
    return { state };
}

export default connect(mapStateToProps)(GoodnightProcess);
